export default class ConfigurationSummaryToastMessage {
    static getAddToCartFail(localizedInformationOrTranslations) {
        const label = 'translations' in localizedInformationOrTranslations
            ? localizedInformationOrTranslations.translations.addToShoppingCartErrorMessage
            : localizedInformationOrTranslations.addToShoppingCartErrorMessage;
        return {
            label
        };
    }
    static getAddToListFail(localizedInformationOrTranslations) {
        const label = 'translations' in localizedInformationOrTranslations
            ? localizedInformationOrTranslations.translations.addToShoppingListErrorMessage
            : localizedInformationOrTranslations.addToShoppingListErrorMessage;
        return {
            label
        };
    }
    static getAddToCartAndListFail(localizedInformationOrTranslations) {
        const label = 'translations' in localizedInformationOrTranslations
            ? localizedInformationOrTranslations.translations.addToShoppingBagAndListErrorMessage
            : localizedInformationOrTranslations.addToShoppingBagAndListErrorMessage;
        return {
            label
        };
    }
}
//# sourceMappingURL=ConfigurationSummaryToastMessage.js.map